import React from 'react'
import { generatePath } from 'react-router-dom'
import { Redirect } from 'react-router-dom'

import BuyXGetYForm from '@/components-latest/ui/OfferPage/BuyXGetY/BuyXGetYForm'
import CreateCartDiscountForm from '@/components-latest/ui/OfferPage/CreateCartDiscountForm/CreateCartDiscountForm'
import OfferDetailsFormWrapper from '@/components-latest/ui/OfferPage/OfferDetailsFormWrapper'
import { ENVIRONMENT } from '@/constants/env'
import AccountPage from '@/pages-latest/AccountPage/AccountPage'
import BillingPage from '@/pages-latest/BillingPage/BillingPage'
import BranchManagementPage from '@/pages-latest/BranchManagementPage/BranchManagementPage'
import EmailVerificationPage from '@/pages-latest/EmailVerificationPage/EmailVerificationPage'
import LoginDeniedPage from '@/pages-latest/LoginDeniedPage'
import LoginPage from '@/pages-latest/LoginPage'
import MenuPage from '@/pages-latest/MenuPage'
import OffersPage from '@/pages-latest/OffersPage'
import OrdersPage from '@/pages-latest/OrdersPage'
import Page404 from '@/pages-latest/Page404'
import PerformancePage from '@/pages-latest/PerformancePage'
import RegistrationPage from '@/pages-latest/RegistrationPage'
import TestPage from '@/pages-latest/TestPage/TestPage'

export const PATHS = {
  HOME: '/',
  LOGIN: '/login',
  LOGIN_DENIED: '/login-denied',
  TEST_COMPONENTS: '/test',
  ORDERS: '/orders',
  ORDERS_BY_STATUS: '/orders/:status',
  MENU: '/menu',
  SPECIAL_MENU_TEST: '/special',
  PERFORMANCE: '/performance',
  PERFORMANCE_BY_ID: '/performance/:id',
  ACCOUNT: '/account',
  BILLING: '/billing',
  REGISTRATION: '/registration',
  EMAIL_VERIFICATION: '/registration/verify-email',
  OFFERS: '/offers',
  OFFERS_BY_ID: '/offers/:id',
  OFFERS_CREATE: '/offers/item-discount/create',
  OFFERS_CART_DISCOUNT_CREATE: '/offers/cart-discount/create',
  OFFERS_BUYX_GETY_CREATE: '/offers/buyx-gety/create',
  BRANCH_BUSINESS_HOURS: '/branch/business-hours'
}

export interface RouteConfig {
  element: React.JSX.Element
  path: string
  isProtected?: boolean
  exact?: boolean
  clearLayout?: boolean
  isLatest?: boolean
  forcePublicLayout?: boolean
}

export const routeConfigs: RouteConfig[] = [
  {
    path: '/',
    exact: true,
        element: (
          // @ts-ignore
          <Redirect to={PATHS.ORDERS} />
        )
  },
  {
    path: PATHS.ORDERS,
    exact: true,
    isProtected: true,
        element: (
          // @ts-ignore
          <Redirect to={generatePath(PATHS.ORDERS_BY_STATUS, { status: 'new' })} />
        )
  },
  {
    clearLayout: true,
    path: PATHS.LOGIN,
    exact: true,
    isProtected: false,
    element: <LoginPage />
  },
  {
    path: PATHS.ORDERS_BY_STATUS,
    isProtected: true,
    element: <OrdersPage />
  },
  {
    path: PATHS.MENU,
    exact: true,
    isProtected: true,
    element: <MenuPage />
  },
  {
    path: PATHS.OFFERS,
    exact: true,
    isProtected: true,
    element: (
      // @ts-ignore
      <Redirect
        to={generatePath(PATHS.OFFERS_BY_ID, { id: 'item_discount' })}
      />
    )
  },

  {
    path: PATHS.OFFERS_BY_ID,
    exact: true,
    isProtected: true,
    element: <OffersPage />
  },
  {
    path: PATHS.OFFERS_CREATE,
    exact: true,
    isProtected: true,
    element: <OfferDetailsFormWrapper />
  },
  {
    path: PATHS.OFFERS_CART_DISCOUNT_CREATE,
    isProtected: true,
    element: <CreateCartDiscountForm />
  },
  {
    path: PATHS.OFFERS_BUYX_GETY_CREATE,
    isProtected: true,
    element: <BuyXGetYForm />
  },
  {
    path: PATHS.BRANCH_BUSINESS_HOURS,
    isProtected: true,
    element: <BranchManagementPage />
  },
  {
    path: PATHS.PERFORMANCE,
    exact: true,
    isProtected: true,
    element: (
      // @ts-ignore
      <Redirect to={generatePath(PATHS.PERFORMANCE_BY_ID, { id: 'orders' })} />
    )
  },
  {
    path: PATHS.PERFORMANCE_BY_ID,
    isProtected: true,
    element: <PerformancePage />
  },
  {
    path: PATHS.BILLING,
    exact: true,
    isProtected: true,
    element: <BillingPage />
  },
  {
    path: PATHS.ACCOUNT,
    exact: true,
    isProtected: true,
    element: <AccountPage />
  },
  {
    path: PATHS.LOGIN_DENIED,
    exact: true,
    isProtected: false,
    forcePublicLayout: true,
    element: <LoginDeniedPage />
  },
  {
    path: PATHS.REGISTRATION,
    exact: true,
    clearLayout: true,
    isProtected: false,
    element: <RegistrationPage />
  },
  {
    path: PATHS.EMAIL_VERIFICATION,
    exact: true,
    clearLayout: true,
    isProtected: false,
    element: <EmailVerificationPage />
  },
  ...(ENVIRONMENT !== 'production'
    ? [
        {
          path: PATHS.TEST_COMPONENTS,
          exact: true,
          isProtected: false,
          clearLayout: true,
          element: <TestPage />
        }
      ]
    : []),

  { path: '*', element: <Page404 /> }
]

export default routeConfigs
